export * from './resume.interface';
export * from './resume.model';
